<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-11 09:53:48
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:54:23
-->
<template>
  <div class="innovative innovative-accuffroct" :class="{textj: language != 'en'}" ref="accuffroct">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffroct.title')"></div>
    </div>
    <div class="p-t-90 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1 p-r-20">
            <img class="" :src="$t('product.accuffroct.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-30 p-b-30">
            <div class="innovative-item-title" v-html="$t('product.accuffroct.list[0].title')"></div>
            <div class="p-t-15 textj">
              <p class="p-b-30" v-for="item, index in $t('product.accuffroct.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="accuffroct-advantages innovative-wrap-item">
        <div class="innovative-container">
          <div class="innovative-item-title p-l-15" style="" v-html="$t('product.accuffroct.list[1].title')"></div>
          <div class="innovative-characteristics">
            <div class="flex align_items_center p-t-70 p-b-100">
              <div class="flex_1 trans-list">
                <div class="textc innovative-wrap-item-title textl" v-html="$t('product.accuffroct.list[1].des')[0].title"></div>
                <div class="">
                  <p class="innovative-characteristics-item" v-for="item, index in $t('product.accuffroct.list[1].des')[0].list" :key="index" v-html="item"></p>
                </div>
              </div>
              <div class="flex_1 textr trans-list">
                <img class="" :src="$t('product.accuffroct.list[1].des')[0].img" alt="" srcset="">
              </div>
            </div>
            <div class="p-t-100">
              <el-row :gutter="60" class="flex align_items_center">
                <el-col :span="10" class="trans-list">
                  <img class="" :src="$t('product.accuffroct.list[1].des')[1].img" alt="" srcset="">
                </el-col>
                <el-col :span="14" class="trans-list" :class="language == 'en' ? '' : 'textr'" :style="language == 'en' ? 'padding-left: 10%;' : ''">
                  <div class="ilblk">
                    <div class="innovative-wrap-item-title" v-html="$t('product.accuffroct.list[1].des')[1].title"></div>
                    <div class="textl">
                      <p class="innovative-characteristics-item" v-for="item, index in $t('product.accuffroct.list[1].des')[1].list" :key="index" v-html="item"></p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="innovative-wrap-item p-t-50 p-b-50 article">
        <div class="innovative-item-title" v-html="$t('product.accuffroct.article.title')"></div>
        <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.accuffroct.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-accuffroct {
  .accuffroct-advantages {
    background: #F8FBFF;
    padding: 50PX 0 150PX 0;
    .innovative-item-title {
      width: 298PX;
      height: 45PX;
      background: linear-gradient(270deg, #FFFFFF 0%, #008CDF 50%, rgba(0,192,241,0) 100%);
      text-align: center;
      margin: 0 auto;
    }
    .innovative-characteristics {
      box-shadow: none;
      background: none;
      padding: 0;
      padding-left: 90PX;
    }
    .innovative-characteristics-item {
      line-height: 50PX;
      &::before {
        top: 22PX;
      }
    }
  }
}
.pc.en .innovative-accuffroct {
  .accuffroct-advantages {
    .innovative-characteristics-item {
      line-height: 36PX;
      &::before {
        top: 16PX;
      }
    }
  }
}
</style>
